import React from "react";
import "./widgetLg.css";
const WidgetLg = () => {
  const Button = ({ type }) => {
    return <button className={`widget_lg_button ${type}`}>{type}</button>;
  };
  return (
    <div className="widget_lg">
      <h3 className="widget_lg_title">Latest transactions</h3>
      <table className="widget_lg_table">
        <tr className="widget_lg_tr">
          <th className="widget_lg_th">Customer</th>
          <th className="widget_lg_th">Date</th>
          <th className="widget_lg_th">Amount</th>
          <th className="widget_lg_th">Status</th>
        </tr>

        <tr className="widget_lg_tr">
          <td className="widget_lg_user">
            <img
              src="https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt=""
              className="widget_lg_img"
            />
            <span className="widget_lg_name">Lio Messi</span>
          </td>

          <td className="widget_lg_date">2 jum 2021</td>
          <td className="widget_lg_amount">$ 2343</td>
          <td className="widget_lg_status">
            <Button type="Declined" />
          </td>
        </tr>
        <tr className="widget_lg_tr">
          <td className="widget_lg_user">
            <img
              src="https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt=""
              className="widget_lg_img"
            />
            <span className="widget_lg_name">Lio Messi</span>
          </td>

          <td className="widget_lg_date">2 jum 2021</td>
          <td className="widget_lg_amount">$ 2343</td>
          <td className="widget_lg_status">
            <Button type="Approved" />
          </td>
        </tr>
        <tr className="widget_lg_tr">
          <td className="widget_lg_user">
            <img
              src="https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt=""
              className="widget_lg_img"
            />
            <span className="widget_lg_name">Lio Messi</span>
          </td>

          <td className="widget_lg_date">2 jum 2021</td>
          <td className="widget_lg_amount">$ 2343</td>
          <td className="widget_lg_status">
            <Button type="Approved" />
          </td>
        </tr>
        <tr className="widget_lg_tr">
          <td className="widget_lg_user">
            <img
              src="https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt=""
              className="widget_lg_img"
            />
            <span className="widget_lg_name">Lio Messi</span>
          </td>

          <td className="widget_lg_date">2 jum 2021</td>
          <td className="widget_lg_amount">$ 2343</td>
          <td className="widget_lg_status">
            <Button type="Pending" />
          </td>
        </tr>
      </table>
    </div>
  );
};

export default WidgetLg;
